var _path, _path2, _path3, _path4, _ellipse, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewKent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5397 15.0002C61.0997 5.99055 20.8907 6.68357 14.2681 15.0002C15.9237 20.3905 19.2824 31.2635 19.4716 31.6331C19.6608 32.0027 50.1408 31.3251 65.3571 30.9401L66.5397 15.0002Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5846 40.6429C42.9167 45.1378 37.0935 44.565 26.3305 40.6429L25.8574 32.7885L37.2105 29.0923C39.831 30.046 41.1571 29.958 43.3602 29.0923L55.6594 31.1714L52.5846 40.6429Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6332 51.4997C7.60998 44.9813 4.37291 40.2804 4.33398 32.5567L14.268 15.2307C16.8082 19.2024 22.1972 22.3229 38.1568 29.3225L16.6332 51.4997Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.938 51.5001C72.2164 42.9527 75.0546 39.7185 76.0007 32.5571L66.5398 15.4622C63.9996 19.4339 58.2615 23.0856 42.1779 29.3229L63.938 51.5001Z",
    fill: "white",
    stroke: "#999999",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.2856,
    cy: 36.9461,
    rx: 2.36523,
    ry: 2.31013,
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9324 24.9123C38.057 23.3779 43.233 23.3402 52.5847 24.9123",
    stroke: "#999999",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewKent);
export default __webpack_public_path__ + "static/media/new_kent.d96083edf18f27c0311554215c11e023.svg";
export { ForwardRef as ReactComponent };